/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */
import {
  CALLBACK_ON_MESSAGE,
  MESSAGE_TYPE_CONFIRM_SUBSCRIBE,
  MESSAGE_TYPE_CONFIRM_UNSUBSCRIBE,
  MESSAGE_TYPE_PONG,
  PROTOCOL_MESSAGE_TYPES,
  WIRE_ACTION_SUBSCRIBE,
  WIRE_ACTION_UNSUBSCRIBE,
} from './messageTypes';

export const parseInboundMessage = rawData => {
  try {
    return JSON.parse(rawData);
  } catch {
    return null;
  }
};

export const isProtocolMessage = message => {
  return message?.type && PROTOCOL_MESSAGE_TYPES.has(message.type);
};

export const handleProtocolMessage = (
  message,
  {
    pendingWireOps,
    serverSubscribed,
    onSubscribeSucceeded,
    onSubscribeFailed,
    onUnsubscribeSucceeded,
    onUnsubscribeFailed,
  }
) => {
  const clientMessageId = message?.clientMessageId;
  const pendingOp = clientMessageId ? pendingWireOps.get(clientMessageId) : undefined;

  if (!pendingOp) {
    return;
  }

  if (message.type === MESSAGE_TYPE_CONFIRM_SUBSCRIBE && pendingOp.action === WIRE_ACTION_SUBSCRIBE) {
    if (message?.success) {
      serverSubscribed.add(pendingOp.topicKey);
      onSubscribeSucceeded?.(pendingOp, message);
    } else {
      onSubscribeFailed?.(pendingOp, message);
    }

    pendingWireOps.delete(clientMessageId);

    return;
  }

  if (message.type === MESSAGE_TYPE_CONFIRM_UNSUBSCRIBE && pendingOp.action === WIRE_ACTION_UNSUBSCRIBE) {
    if (message?.success) {
      serverSubscribed.delete(pendingOp.topicKey);
      onUnsubscribeSucceeded?.(pendingOp, message);
    } else {
      onUnsubscribeFailed?.(pendingOp, message);
    }

    pendingWireOps.delete(clientMessageId);
  }
};

export const shouldIgnoreInboundMessage = message => {
  if (message?.type === MESSAGE_TYPE_PONG) {
    return true;
  }

  if (message?.type === MESSAGE_TYPE_CONFIRM_SUBSCRIBE || message?.type === MESSAGE_TYPE_CONFIRM_UNSUBSCRIBE) {
    return true;
  }

  return false;
};

export const getHandlersForMessage = (message, subscriptions) => {
  const service = message?.service;
  const eventType = message?.eventType;

  if (!service || !eventType) {
    return [];
  }

  const handlers = [];

  subscriptions.forEach(subscription => {
    if (subscription.service === service && subscription.eventType === eventType) {
      handlers.push(subscription?.[CALLBACK_ON_MESSAGE]);
    }
  });

  return handlers;
};
